const HANDLED_TTL_MS = 10_000;
const handledFingerprints = new Map<string, number>();

const LOCATION_LIMIT = 3;

function parseStackLocations(stack: string | undefined): string[] {
  if (!stack) return [];
  const re = /([^\s()@]+):(\d+):(\d+)/g;
  const locs: string[] = [];
  let m: RegExpExecArray | null;
  while ((m = re.exec(stack)) !== null && locs.length < LOCATION_LIMIT) {
    locs.push(`${m[1]}:${m[2]}:${m[3]}`);
  }
  return locs.sort();
}

function fingerprintFromError(error: unknown): string | null {
  if (!(error instanceof Error)) return null;
  const locs = parseStackLocations(error.stack).join("|");
  return `${error.name}::${error.message}::${locs}`;
}

function fingerprintFromEvent(event: {
  properties?: Record<string, any>;
}): string | null {
  const ex = event.properties?.$exception_list?.[0];
  if (!ex) return null;
  const locs = (ex.stacktrace?.frames ?? [])
    .slice(0, LOCATION_LIMIT)
    .map((f: any) => `${f.filename ?? ""}:${f.lineno ?? ""}:${f.colno ?? ""}`)
    .sort()
    .join("|");
  return `${ex.type ?? "Error"}::${ex.value ?? ""}::${locs}`;
}

function sweep() {
  const cutoff = Date.now() - HANDLED_TTL_MS;
  handledFingerprints.forEach((ts, fp) => {
    if (ts < cutoff) handledFingerprints.delete(fp);
  });
}

export function markErrorHandled(error: unknown): void {
  const fp = fingerprintFromError(error);
  if (!fp) return;
  sweep();
  handledFingerprints.set(fp, Date.now());
}

/** Same check as `wasExceptionHandled`, against the error object itself. */
export function wasErrorHandled(error: unknown): boolean {
  const fp = fingerprintFromError(error);
  if (!fp) return false;
  sweep();
  return handledFingerprints.has(fp);
}

export function wasExceptionHandled(event: {
  properties?: Record<string, any>;
}): boolean {
  sweep();
  const fp = fingerprintFromEvent(event);
  if (!fp) return false;
  return handledFingerprints.has(fp);
}
